import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 220,
  },
});

class ConfirmationSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpened: false,
      unconfirmedEvent: null,
      selectionAdditionalInfo: null,
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <FormControl
          className={`select ${classes.formControl}`}
          component={Paper}
          elevation={3}
        >
          <Select
            value={this.props.value}
            onChange={(event) => {
              this.setState({
                dialogOpened: true,
                unconfirmedEvent: event,
              });
              if (this.props.getSelectionInfoCallback) {
                this.props
                  .getSelectionInfoCallback(event.target.value)
                  .then((x) => this.setState({ selectionAdditionalInfo: x }));
              }
            }}
            displayEmpty
            variant="outlined"
          >
            {this.props.children}
          </Select>
        </FormControl>

        <Dialog
          aria-labelledby="simple-dialog-title"
          open={this.state.dialogOpened}
          className="dialog"
        >
          <DialogTitle id="simple-dialog-title">{this.props.title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.props.confirmationMessage}
            </DialogContentText>
            <DialogContentText id="alert-dialog-description">
              {this.state.dialogOpened
                ? "Target Value: " + this.state.unconfirmedEvent.target.value
                : ""}
            </DialogContentText>
            <DialogContentText id="alert-dialog-description">
              {this.state.selectionAdditionalInfo}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({ dialogOpened: false });
              }}
              variant="contained"
              color="default"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                this.props.onChange(this.state.unconfirmedEvent);
                this.setState({ dialogOpened: false });
              }}
              variant="contained"
              color="primary"
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(ConfirmationSelector);
